export enum FacebookReactions {
  LIKE,
  LOVE,
  HAHA,
  WOW,
  ANGRY,
  COMMENT,
  REPLY
}
